import { render, staticRenderFns } from "./addExam.vue?vue&type=template&id=5c1e091b&"
import script from "./addExam.vue?vue&type=script&lang=js&"
export * from "./addExam.vue?vue&type=script&lang=js&"
import style0 from "./addExam.vue?vue&type=style&index=0&id=5c1e091b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports